import { useDispatch } from 'react-redux';

import { Actions } from '../types';

const useThunkDispatch = () => useDispatch<Actions.ThunkDispatch>();

export default useThunkDispatch;
